import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "material-icons/iconfont/material-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import emailjs from "emailjs-com"

emailjs.init(process.env.REACT_APP_EMAILJS_USER_ID as string)


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

